module.exports = __webpack_public_path__ + "img/Noctiluca-Process-2-mobile.d643ca41.png";